/* eslint-disable consumerweb/require-pagename */
import React, { useEffect, useRef, useState } from 'react'
import _ from 'lodash'
import PropTypes from 'prop-types'
import glamorous from 'glamorous'
import { CardStyles, OverrideStyles } from './styles'
import { greyBackgroundAndSmaller } from 'lib/styles/media-queries'
import { css } from '../../../../../lib/paypalphrodite'
import content from 'pp-react-l10n'
import {
  Spot,
  Button,
  HeadingText,
  BodyText,
  SingleSelectionGroup,
  Link,
  CaptionText,
  Alert,
} from '@paypalcorp/pp-react'
import { PAYMENT_TYPE } from '../../../../../../../lib/constants'
import { mobileAndSmaller } from '../../../../../lib/styles/media-queries'
import { paymentTypeUrlMap } from '..'
import {
  trackClickUnifiedSend,
  trackGuestReturnToPagePmtChoice,
} from '../../../../utils/unified-send-analytics'
import { connect } from 'transfer/utils/p2p-connect'
import * as UnifiedActions from 'transfer/actions/unified-actions'
import { routeTo } from '../../../../utils/routeHelper'
import { handleInterstitialCipFlow } from '../../../../utils/homeInfoUtils'
import * as ViewActions from '../../../../actions/Actions'
import {
  redirectToDolphin,
  togglePaymentTypeChoiceOverpanel,
} from '../../../../actions/unified-actions'
import { getDefaultPaymentType } from 'transfer/components/unified/payment-type-choice/helpers'
import classNames from 'classnames'
import { tracking } from '../../../../../lib/analytics/mParticle'
import Events from '../../../../../lib/analytics/eventTags'
import serverProps from '../../../../utils/serverProps'
import * as OverpanelActions from '../../../../../transfer/actions/overpanels'

const i18nPaymentType = content('transfer/inc/paymentTypeChoices')
const purchaseProtectionLink = '/webapps/mpp/paypal-safety-and-security'
let i18n = content('transfer/alert')
const CDN_HOST_NAME = _.get(serverProps, 'cdnHostName')

const Container = glamorous.div({
  display: 'flex',
  alignItems: 'center',
  flexDirection: 'column',
  justifyContent: 'center',
})

const Header = glamorous.div({
  textAlign: 'center',
  marginBottom: '24px',
  maxWidth: 500,
})

const ButtonContainer = glamorous.div({
  marginTop: '32px',
  textAlign: 'center',
  [mobileAndSmaller]: {
    width: '100%',
    padding: '1rem',
    position: 'absolute',
    bottom: 0,
  },
})

const OptionContainer = glamorous.div({
  display: 'flex',
  width: '100%',
})

const OptionContainerIcon = glamorous.div({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  margin: '24px 16px',
  [mobileAndSmaller]: {
    margin: '16px',
  },
})

const OptionContainerText = glamorous.div({
  textAlign: 'left',
  margin: '24px 0px',
  [mobileAndSmaller]: {
    margin: '16px 0px',
  },
})

const OptionSelectIconContainer = glamorous.div({
  display: 'flex',
  marginLeft: 'auto',
})

const ContentDisplayDiv = glamorous.div({
  padding: '0 4.25rem',
  [greyBackgroundAndSmaller]: {
    padding: 0,
  },
})
const PanelDetailsList = glamorous.ul({
  marginTop: '1.25rem',
})
const ButtonLinksDiv = glamorous.div({
  textAlign: 'center',
  margin: '3rem 0 1.5rem',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
})

const FriendsAndFamily = ({ selectedPaymentType }) => {
  const isSelected = selectedPaymentType === PAYMENT_TYPE.PERSONAL
  const spotClassNames = {
    [css(OverrideStyles.acceptSpot)]: true,
    [css(OverrideStyles.acceptSpotHidden)]: !isSelected,
  }

  return (
    <OptionContainer>
      <OptionContainerIcon>
        <Spot name="crowdfund" aria-hidden={true} data-testid="personal-icon" />
      </OptionContainerIcon>
      <OptionContainerText>
        <BodyText theme="v2" strong>
          {i18nPaymentType('t12.personal.title')}
        </BodyText>
        <CaptionText theme="v2">
          {i18nPaymentType('t12.personal.description')}
        </CaptionText>
      </OptionContainerText>
      <OptionSelectIconContainer>
        <OptionContainerIcon>
          <Spot
            name="accept"
            size="sm"
            className={classNames(spotClassNames)}
            aria-hidden={true}
          />
        </OptionContainerIcon>
      </OptionSelectIconContainer>
    </OptionContainer>
  )
}

FriendsAndFamily.propTypes = {
  selectedPaymentType: PropTypes.string,
}

const GoodsAndServices = ({ selectedPaymentType }) => {
  const isSelected = selectedPaymentType === PAYMENT_TYPE.PURCHASE
  const spotClassNames = {
    [css(OverrideStyles.acceptSpot)]: true,
    [css(OverrideStyles.acceptSpotHidden)]: !isSelected,
  }

  return (
    <OptionContainer>
      <OptionContainerIcon>
        <Spot name="merchant" aria-hidden={true} data-testid="purchase-icon" />
      </OptionContainerIcon>
      <OptionContainerText>
        <BodyText theme="v2" strong>
          {i18nPaymentType('t12.purchaseProtection.title')}
        </BodyText>
        <CaptionText theme="v2">
          {i18nPaymentType('t12.purchaseProtection.description')}
        </CaptionText>
      </OptionContainerText>
      <OptionSelectIconContainer>
        <OptionContainerIcon>
          <Spot
            name="accept"
            size="sm"
            className={classNames(spotClassNames)}
            aria-hidden={true}
          />
        </OptionContainerIcon>
      </OptionSelectIconContainer>
    </OptionContainer>
  )
}

GoodsAndServices.propTypes = {
  selectedPaymentType: PropTypes.string,
}

const PaymentTypeChoiceSelector = props => {
  const {
    amount,
    variant,
    isGuest,
    payerId,
    flowType,
    dispatch,
    recipient,
    isPurchase,
    displayName,
    handleClose,
    showMessage,
    thumbnailUrl,
    currencyCode,
    isPersonalDisabled,
    isPurchaseDisabled,
    highlightPaymentType,
    paymentTypeIsSelected,
    purchaseToPersonalTransitionMessage,
    purchaseToPersonalTransactionPanel,
    purchaseToPersonalTransactionPanelVisibility,
    handleCloseForOtherFlow,
    paymentTypeSelectionMessage,
    triggerSenderPhoneConfirmation,
    moneyPageOverPanel,
    suggestedDesign,
    fromCurrencyCode,
    recipientAccountType,
    recipientCountry,
    noteLength,
  } = props

  const flowUrl = useRef(null)
  const targetFlowType = useRef(flowType)
  const [paymentType, setPaymentType] = useState(
    getDefaultPaymentType({
      flowType,
      isPurchase,
      defaultPaymentType: highlightPaymentType,
    })
  )

  const initialPaymentType = useRef(paymentType)

  useEffect(() => {
    return function cleanup() {
      if (flowType !== 'payRequest' && triggerSenderPhoneConfirmation) {
        const localFlowType = targetFlowType.current
        const data = {
          amount,
          payerId,
          flowType: localFlowType,
          recipient,
          displayName,
          currencyCode,
          thumbnailUrl,
        }

        dispatch(redirectToDolphin(data))
      } else if (flowUrl.current && flowUrl.current !== 'payRequest') {
        routeTo(flowUrl.current)
      }
    }
  }, [])

  const close = nextFlowType => {
    const isPayRequest = flowType === 'payRequest'
    let shouldUpdateTransactionData = false

    if (isPayRequest) {
      if (!paymentTypeIsSelected) {
        shouldUpdateTransactionData = true
      } else {
        const preFlowType = isPurchase ? 'buy' : 'send'
        if (preFlowType !== nextFlowType) {
          shouldUpdateTransactionData = true
        }
      }
    } else if (nextFlowType && nextFlowType !== flowType) {
      shouldUpdateTransactionData = true
    }

    if (shouldUpdateTransactionData) {
      let pageAction
      shouldUpdateTransactionData = true
      targetFlowType.current = nextFlowType
      if (isGuest) {
        pageAction = nextFlowType === 'send' ? 'guestSelectFF' : 'guestSelectGS'
      } else {
        pageAction = nextFlowType === 'send' ? 'selectFF' : 'selectGS'
      }

      trackClickUnifiedSend(pageAction)
      dispatch(
        UnifiedActions.changedPurchaseProtection({
          currentPurchaseProtection: nextFlowType === 'buy',
          changedPurchaseProtection: true,
        })
      )

      if (isGuest) {
        trackGuestReturnToPagePmtChoice(pageAction)
      }

      handleCloseForOtherFlow(shouldUpdateTransactionData, {
        isPurchase: nextFlowType === 'buy',
      })
    }
  }

  const handleNextButton = newPaymentType => {
    let nextFlowType = newPaymentType === PAYMENT_TYPE.PURCHASE ? 'buy' : 'send'
    let shouldUpdateTransactionData = false

    const isPayRequest = flowType === 'payRequest'

    if (isPersonalDisabled && nextFlowType === 'send') {
      return handleInterstitialCipFlow(nextFlowType)
    }

    if (isPurchaseDisabled && nextFlowType === 'buy') {
      return handleInterstitialCipFlow(nextFlowType)
    }

    if (handleCloseForOtherFlow) {
      return close(nextFlowType)
    }

    const url = !isPayRequest ? paymentTypeUrlMap[nextFlowType] : 'payRequest'

    if (isPayRequest) {
      if (!paymentTypeIsSelected) {
        shouldUpdateTransactionData = true
      } else {
        const preFlowType = isPurchase ? 'buy' : 'send'
        if (preFlowType !== nextFlowType) {
          shouldUpdateTransactionData = true
        }
      }
    } else if (nextFlowType && nextFlowType !== flowType) {
      shouldUpdateTransactionData = true
    }

    if (shouldUpdateTransactionData) {
      flowUrl.current = url
      targetFlowType.current = nextFlowType
      shouldUpdateTransactionData = true
    }

    dispatch(ViewActions.setPaymentTypeSelected(true))
    handleClose(shouldUpdateTransactionData, {
      isPurchase: nextFlowType === 'buy',
    })
  }

  const handleContinueButton = () => {
    trackClickUnifiedSend('continue')
    tracking(
      Events.p2p_payment_type_continue_pressed({
        protection_design: moneyPageOverPanel,
        suggested_protection_design: suggestedDesign,
        sender_currency: fromCurrencyCode,
        receiver_account_type: recipientAccountType,
        receiver_country: recipientCountry,
        receiver_currency: currencyCode,
        note_character_length: noteLength,
        payment_type: paymentType,
      })
    )
    if (
      purchaseToPersonalTransactionPanel &&
      initialPaymentType.current === PAYMENT_TYPE.PURCHASE &&
      paymentType === PAYMENT_TYPE.PERSONAL
    ) {
      tracking(Events.p2p_protection_overpanel_shown())
      dispatch(
        OverpanelActions.setPurchaseToPersonalTransactionPanelVisibility(true)
      )
      dispatch(togglePaymentTypeChoiceOverpanel({ show: false }))
      return
    }
    handleNextButton(paymentType)
  }

  const changePaymentType = event => {
    const nextPaymentType = event.target.value
    trackClickUnifiedSend(
      nextPaymentType === PAYMENT_TYPE.PERSONAL ? 'selectFF' : 'selectGS'
    )
    if (
      purchaseToPersonalTransitionMessage &&
      nextPaymentType === PAYMENT_TYPE.PERSONAL
    ) {
      tracking(Events.p2p_payment_type_transition_message())
    }
    setPaymentType(nextPaymentType)
  }

  let options
  if (variant === 'T12') {
    options = [
      {
        value: PAYMENT_TYPE.PERSONAL,
        label: <FriendsAndFamily selectedPaymentType={paymentType} />,
        className: css(CardStyles.container),
      },
      {
        value: PAYMENT_TYPE.PURCHASE,
        label: <GoodsAndServices selectedPaymentType={paymentType} />,
        className: css(CardStyles.container),
      },
    ]
  } else if (variant === 'T13') {
    options = [
      {
        value: PAYMENT_TYPE.PURCHASE,
        label: <GoodsAndServices selectedPaymentType={paymentType} />,
        className: css(CardStyles.container),
      },
      {
        value: PAYMENT_TYPE.PERSONAL,
        label: <FriendsAndFamily selectedPaymentType={paymentType} />,
        className: css(CardStyles.container),
      },
    ]
  }

  const selectionOptions = {
    label: i18nPaymentType('t12.label'),
    align: 'vertical',
    value: paymentType,
    name: 'paymentType',
    onChange: changePaymentType,
    hideLabel: true,
    options,
  }

  const recipientText = displayName || recipient
  let description
  if (
    showMessage &&
    paymentTypeSelectionMessage &&
    paymentTypeSelectionMessage.length > 0
  ) {
    description = (
      <Alert
        theme="v2"
        type="warning"
        data-testid="payment-type-selection-message"
      >
        {paymentTypeSelectionMessage}
      </Alert>
    )
  } else if (purchaseToPersonalTransitionMessage) {
    if (paymentType === PAYMENT_TYPE.PERSONAL) {
      description = (
        <Alert
          theme="v2"
          type="warning"
          typeIconAriaLabel={i18n('warning.icon.label')}
          data-testid="purchase-to-personal-transition-message"
        >
          {purchaseToPersonalTransitionMessage}
        </Alert>
      )
    }
  } else {
    description = (
      <BodyText
        theme="v2"
        data-testid="description"
        className={css(CardStyles.bodyText)}
      >
        {i18nPaymentType('t12.description', { recipient: recipientText })}
      </BodyText>
    )
  }

  const showNextButton =
    paymentType === PAYMENT_TYPE.PERSONAL ||
    paymentType === PAYMENT_TYPE.PURCHASE

  const purchaseToPersonalTransactionPanelDetails =
    purchaseToPersonalTransactionPanel &&
    purchaseToPersonalTransactionPanel.details.map((dataMsg, key) => (
      <BodyText as="li" id={key}>
        {dataMsg}
      </BodyText>
    ))

  return (
    <Container>
      {purchaseToPersonalTransactionPanelVisibility ? (
        <>
          <img
            style={{ width: '8.25rem' }}
            src={`${CDN_HOST_NAME}/paypal-ui/illustrations/focused/svg/empty-warning.svg`}
            alt="empty-warning"
          />
          <ContentDisplayDiv>
            <HeadingText as="h2" size="sm" style={{ textAlign: 'center' }}>
              {purchaseToPersonalTransactionPanel.title}
            </HeadingText>
            <BodyText>{purchaseToPersonalTransactionPanel.message}</BodyText>
            <BodyText as={PanelDetailsList}>
              {purchaseToPersonalTransactionPanelDetails}
            </BodyText>
            <ButtonLinksDiv>
              <Button
                type="button"
                onClick={() => {
                  tracking(Events.p2p_protection_overpanel_gns_pressed())
                  handleNextButton(PAYMENT_TYPE.PURCHASE)
                }}
              >
                {i18nPaymentType('SwitchToGoodsAndServices')}
              </Button>
              <Button
                tertiary={true}
                type="button"
                onClick={() => {
                  tracking(Events.p2p_protection_overpanel_fnf_pressed())
                  handleNextButton(PAYMENT_TYPE.PERSONAL)
                }}
                style={{ marginTop: '1.5rem' }}
              >
                {i18nPaymentType('KeepFriendsAndFamily')}
              </Button>
            </ButtonLinksDiv>
          </ContentDisplayDiv>
        </>
      ) : (
        <>
          <Header>
            <HeadingText
              className={css(CardStyles.headingText)}
              theme="v2"
              level={2}
              data-testid="title"
            >
              {i18nPaymentType('t12.label')}
            </HeadingText>
            {description}
          </Header>
          <SingleSelectionGroup theme="v2" {...selectionOptions} />
          <Link
            size="sm"
            theme="v2"
            onClick={() => trackClickUnifiedSend('purchaseProtection')}
            href={purchaseProtectionLink}
            target="_blank"
            className={css(OverrideStyles.purchaseProtectionLink)}
          >
            {i18nPaymentType('purchaseProtectionGnsLink')}
          </Link>
          <ButtonContainer>
            {showNextButton && (
              <Button
                data-testid="nextButton"
                theme="v2"
                onClick={handleContinueButton}
                size="lg"
                className={css(OverrideStyles.button)}
              >
                {i18nPaymentType('t12.continueButtonText')}
              </Button>
            )}
          </ButtonContainer>
        </>
      )}
    </Container>
  )
}

PaymentTypeChoiceSelector.propTypes = {
  showMessage: PropTypes.bool,
  dispatch: PropTypes.func.isRequired,
  flowType: PropTypes.string,
  handleClose: PropTypes.func,
  handleCloseForOtherFlow: PropTypes.func,
  highlightPaymentType: PropTypes.string,
  isGuest: PropTypes.bool,
  hasSelectedFundingOption: PropTypes.bool,
  triggerSenderPhoneConfirmation: PropTypes.bool,
  amount: PropTypes.any,
  currencyCode: PropTypes.string,
  thumbnailUrl: PropTypes.string,
  displayName: PropTypes.string,
  recipient: PropTypes.string,
  payerId: PropTypes.string,
  isPurchase: PropTypes.bool,
  paymentTypeIsSelected: PropTypes.bool,
  purchaseToPersonalTransactionPanelVisibility: PropTypes.bool,
  purchaseToPersonalTransitionMessage: PropTypes.string,
  purchaseToPersonalTransactionPanel: PropTypes.object,
  isPersonalDisabled: PropTypes.bool,
  isPurchaseDisabled: PropTypes.bool,
  variant: PropTypes.oneOf(['T12', 'T13']),
  paymentTypeSelectionMessage: PropTypes.string,
  moneyPageOverPanel: PropTypes.string,
  noteLength: PropTypes.number,
  recipientCountry: PropTypes.string,
  recipientAccountType: PropTypes.string,
  fromCurrencyCode: PropTypes.string,
  suggestedDesign: PropTypes.string,
}

export default connect(
  ({ server, transaction, recipient, amount, user, note, overpanels }) => ({
    paymentTypeSelectionMessage: recipient.paymentTypeSelectionMessage,
    transaction: transaction.isPurchase,
    purchaseToPersonalTransactionPanelVisibility:
      overpanels.purchaseToPersonalTransactionPanelVisibility,
    highlightPaymentType: recipient.highlightPaymentType,
    triggerSenderPhoneConfirmation:
      server.triggerSenderPhoneConfirmation ||
      user.triggerSenderPhoneConfirmation,
    displayName: recipient.displayName,
    thumbnailUrl: recipient.thumbnailUrl,
    amount: amount.amount,
    currencyCode: amount.currencyCode,
    recipient: recipient.recipient,
    payerId: recipient.payerId,
    isPurchase: transaction.isPurchase,
    paymentTypeIsSelected: transaction.paymentTypeIsSelected,
    purchaseToPersonalTransitionMessage:
      _.get(
        transaction,
        'paymentTypeTransitions.purchaseToPersonalTransition.message'
      ) || '',
    purchaseToPersonalTransactionPanel: _.get(
      transaction,
      'paymentTypeTransitions.purchaseToPersonalTransition.panel'
    ),
    isPersonalDisabled: user.isPersonalDisabled,
    isPurchaseDisabled: user.isPurchaseDisabled,
    noteLength: note.note.length,
    moneyPageOverPanel: recipient.moneyPageOverPanel,
    recipientCountry: recipient.country,
    recipientAccountType: recipient.recipientAccountType,
    suggestedDesign: recipient.suggestedDesign,
    fromCurrencyCode: amount.fromCurrencyCode,
  })
)(PaymentTypeChoiceSelector)
